import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

let localopts;
let localconfig;
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'development'){
    localopts = require('./testopts.json');
}
console.log(localopts);

Vue.use(Vuex);

export default  new Vuex.Store({
    state: {
        opts: {
            showDirectory : false
        },
        runtime : {
            activeCategories:[],
            svgCache:{},
            isAdmin:false,
        }

    },
    getters: {
        opts: state => state.opts,
        mainImg : state => state.opts.img,
        genOpt : (state) => (payload) => {
           // console.log(payload);
           // console.log(state.opts[payload.key]);
            return state.opts[payload.key]},
        repeaterGroupItem : (state) =>(payload) =>{
            const group = state.opts[payload.group];
            const item_arr = group.filter(function (i){
                return i.id === payload.id
            });

            return  item_arr[0][payload.key]
        },
        repeaterGroupItems : (state) =>(payload) =>{
            const group = state.opts[payload.group];
            return  group.filter(function (i){
                return i[payload.key] === payload.value
            });
        },
        svgCache: (state)=>{
            if (typeof state.runtime.svgCache !== 'undefined') {
                return state.runtime.svgCache
            } else {return {}}
        },
        rtVisCats : (state) => {
            if (typeof state.runtime.activeCategories !== 'undefined') {
                    return state.runtime.activeCategories
                } else {return []}
        },
        isAdmin :state => state.runtime.isAdmin,
    },
    mutations: {
        SET_OPTS (state, opts) {
            state.opts = opts
        },
        SET_MAIN_IMG (state, img){
            state.opts.img = img;
        },
        SET_GEN_OPT (state, args){
            const key = args.key;
            const value = args.value;
            state.opts[key] = value;
        },
        SET_NESTED_OPT (state, args){
            const groupKey = args.groupKey;
            const key = args.key;
            const value = args.value;
            state.opts[groupKey][key] = value;
        },
        SET_RG_ITEM (state, args){
            let group = state.opts[args.group];
            const key = args.key;
            const value = args.value;
            let idx;
            const item_arr = group.filter(function (i,x){
                if (i.id === args.id){
                    idx = x;
                }
                return i.id === args.id;
            });
            item_arr[0][key] = value;
            state.opts[args.group].splice(idx,1, item_arr[0]);
        },
        ADD_RG_ITEM (state, args){
            console.log('mutation:',args)
            state.opts[args.group].push(args.item);
        },
        DEL_RG_ITEM (state, args){
            const group = args.data.group;
            const id = args.data.id;
            const idx = state.opts[group].findIndex((g)=>{return g.id === id});
            state.opts[group].splice(idx,1);
        },
        SET_RUNTIME (state, args){
            let runtime = {};
            Object.keys(args).forEach((key)=>{
                runtime[key] = args[key];
            })
            state.runtime = runtime;
        },
        ADD_VIS_CAT (state, args){
            let cats = state.runtime.activeCategories;
            if (!cats.includes(args.id)){
                cats.push(args.id)
            }
        },
        DEL_VIS_CAT (state, args){
            let cats = state.runtime.activeCategories;
            if (cats.includes(args.id)){
                const idx = cats.indexOf(args.id)
                cats.splice(idx,1)
            }
        },
        ADD_SVG (state, args) {
            let svgCache = state.runtime.svgCache;
           // svgCache[] = ;
           // state.runtime = runtime;
            Vue.set(state.runtime.svgCache, args.url , args.str)
        }
    },
    actions: {
        loadOpts ({commit}, payload) {
            const url = payload.url;
            const isAdmin = payload.isAdmin;
            console.log(process.env.NODE_ENV);
            if (process.env.NODE_ENV === 'development'){
                commit('SET_OPTS', localopts);
                const runtimeObj = {
                    activeCategories: [],
                    svgCache : {},
                    isAdmin : isAdmin
                };
                commit('SET_RUNTIME', runtimeObj);
            }
            else {
                //attempt to determine if there is a wp instance we can get json from
                const apiAvail = window.IntImg ?  true : false;
                if (apiAvail){
                    axios
                        .get(url)
                        .then(r => r.data)
                        .then(opts => {
                            commit('SET_OPTS', opts);
                            const runtimeObj = {
                                activeCategories: opts.activeCategories,
                                svgCache : {},
                                isAdmin : isAdmin
                            };
                            commit('SET_RUNTIME', runtimeObj);
                        })
                } else {
                   console.error( 'no api available');
                }
            }






        },
        updateMainImg ({commit}, img){
            commit('SET_MAIN_IMG', img)
        },
        updateGenOpt ({commit}, payload){
            commit('SET_GEN_OPT', payload);
        },
        updateNestedOpt ({commit}, payload){
            // console.log('setting', payload);
            commit('SET_NESTED_OPT', payload);
        },
        updateRepeaterGroupItem({commit}, payload){
            commit('SET_RG_ITEM', payload);
        },
        addRepeaterGroupItem({commit}, payload){
            console.log('action:',payload)
            commit('ADD_RG_ITEM', payload)
        },
        delRepeaterGroupItem({commit, getters}, data) {
            commit('DEL_RG_ITEM', {data, getters})
        },
        addVisibleCat({commit}, payload){
            commit( 'ADD_VIS_CAT', payload)
        },
        removeVisibleCat({commit}, payload){
            commit( 'DEL_VIS_CAT', payload)
        },
        reqSVG({commit, getters}, payload){
            if (getters.svgCache.hasOwnProperty(payload.url)){
                //do nothing
            } else {
                const url = atob(payload.url);
                commit('ADD_SVG', {url : payload.url, str:null});
                axios.get(url)
                    .then((response) => {
                           // console.log(response.data)
                            commit('ADD_SVG', {url : payload.url, str:response.data});
                            resolve ('yay');
                        })
                    .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            // console.log(error.response.data);
                            // console.log(error.response.status);
                            // console.log(error.response.headers);
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                           // console.log(error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                          //  console.log('Error', error.message);
                        }
                       // console.log(error.config);
                    });


            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js